module.exports = __webpack_public_path__ + "img/contacts.46f86de3.svg";